import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'

import * as state from '../../state'

/**
 * App-owned navigation link that routes user intent through
 * {@link state.navigation.Feature} before Angular Router starts heavy route
 * work.
 */
@ngCore.Directive({
  host: {
    '[attr.href]': 'hrefSg()',
    '(click)': 'clickHandler($event)',
  },
  selector: 'a[atnPlatformNavigationLink]',
  standalone: true,
})
export class NavigationLinkDirective {
  /** Target URL for this link. */
  public readonly urlSg = ngCore.input<
    string | ngRouter.UrlTree | undefined
  >(undefined, {
    alias: 'atnPlatformNavigationLink',
  })

  private readonly _navigationFeature = ngCore.inject(
    state.navigation.Feature,
  )
  private readonly _router = ngCore.inject(ngRouter.Router)

  /** Browser-visible href, preserving normal link affordances. */
  public readonly hrefSg = ngCore.computed(() => {
    const url = this.urlSg()

    return url instanceof ngRouter.UrlTree
      ? this._router.serializeUrl(url)
      : url
  })

  /** Starts state-owned navigation for ordinary left-clicks. */
  public clickHandler(event: MouseEvent): void {
    const url = this.urlSg()

    if (
      !url ||
      event.button !== 0 ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey
    ) {
      return
    }

    event.preventDefault()

    this._navigationFeature.actions.navigate
      .from('NavigationLink.Clicked')
      .dispatch({ url })
  }
}
